export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-chord/src/constant.js
// module id = 1227
// module chunks = 0